import React, { Component } from 'react';
import { Grid } from '@material-ui/core';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';
import Typo from './CustomTypo';
const styles = theme => ({
    link: {
        ...theme.typography.body2,
        textDecoration: 'unset',
        cursor: 'pointer',
        textAlign: 'center',
    },
    underline:{
        textDecoration: 'underline',
    },
    primary:
    {
        color: theme.palette.text.link
    },
    secondary: {
        color: theme.palette.secondary.main
    },
    onPrimary: {
        color: theme.palette.text.onPrimary
    },
    light: {
        color: theme.palette.text.light
    },
    blur: {
        color: theme.palette.text.blur
    },
    sm: {
        fontSize: 14,
    },
    lg: {
        fontSize: 18,
    },
});

function LinkRouterComponent(props) {
    if (props.to)
        return (
            <Link to={props.to} target={props.target} onClick={props.onClick} className={classNames(props.classes[props.size], props.classes.link, props.className, props.classes[props.color])}>{props.children}</Link>
        )
    else
        return (
            <Link target={props.target} onClick={props.onClick} className={classNames(props.classes[props.size], props.classes.link, props.className, props.classes[props.color])}>{props.children}</Link>
        )
}

function LinkComponent(props) {
    return (
        <Link to={props.to} onClick={props.onClick} className={classNames(props.classes.link, props.className, props.classes[props.color],props.underline?props.classes.underline:undefined)} >
            <Typo variant='thirdCTA'>{props.children}</Typo>
        </Link>
    )
}

function LinkExt(props) {
    let _onClick = () => {
        if (props.url) {
            window.open(props.url)
        }
    }
    if (props.onClick)
        _onClick = props.onClick;
    return (
        <a onClick={_onClick} className={classNames(props.classes.link, props.className, props.classes[props.color])} >
            {props.children}
        </a>
    )
}

const LinkRouter = withStyles(styles)(LinkRouterComponent);
const LinkCTA = withStyles(styles)(LinkComponent);
const LinkExternal = withStyles(styles)(LinkExt)
const LinkInLine = withStyles(styles)(LinkExt)
export { LinkRouter, LinkCTA, LinkExternal, LinkInLine };